export const Services = {
   "Get_QuickSearch": {
      "path": "https://roldanapisearch.azurewebsites.net",
      "method": "GET",
      "descrp": "method to list results of quick search"
   }
}